import * as React from 'react';
import { ScriptStrategy } from 'gatsby';
import { ConversionPixelData } from '../lib/types';
import renderConversionPixel from '../lib/conversionPixel';
import useTtdSettings from './useTtdSettings';

type RenderPixel = (
    data: ConversionPixelData,
    strategy?: Exclude<ScriptStrategy, ScriptStrategy.offMainThread>,
) => void;

export default function useConversionPixel(): RenderPixel {
    const { hasTtdPixel, advertiserId } = useTtdSettings();

    return React.useCallback(
        (
            data: ConversionPixelData,
            strategy?: Exclude<ScriptStrategy, ScriptStrategy.offMainThread>,
        ) => {
            if (hasTtdPixel && advertiserId) {
                renderConversionPixel(advertiserId, data, strategy);
            }
        },
        [hasTtdPixel, advertiserId],
    );
}
